<template>
  <div class="Information">
    <div class="mine_title">
      Teacher's personal information
    </div>
    <!-- 审核状态 -->
    <div style="display: inline-block;">
      <span class="successful" v-if="info.review_status == 1">
        Audit successful
      </span>
      <span class="reviewing" v-if="info.review_status == 0">
        Under review
      </span>
      <span class="failed" v-if="info.review_status == 2">
        Audit failed
        <el-tooltip class="item" effect="dark" placement="top-start" popper-class="tooltipdialog">
          <div slot="content">
            <p style="width: 500px;">
              {{ info.ramark }}
            </p>
          </div>
          <i class="el-icon-info" style="color: #fff;"></i>
        </el-tooltip>
      </span>
    </div>
    <!-- 内容 -->
    <div class="info">
      <div class="info-heard" v-if="info.alias">
        <div class="avatar" @mouseenter="showEditAvatar = true" @mouseleave="showEditAvatar = false"
          @click="openUpload">
          <el-avatar :size="120"
            :src="info.avatar_url ? info.avatar_url : 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'"></el-avatar>
          <div class="avatar-edit" v-show="showEditAvatar">
            <i class="el-icon-camera"></i>
            <span style="font-size: 16px;">Edit</span>
          </div>
        </div>
        <div class="info-name">
          <p>{{ info.alias }}</p>
          <p> {{ info.gender == 2 ? 'FEMALE' : info.gender == 1 ? 'MALE' : info.gender == 0 ? 'Prefer not to disclose' :
            'OTHER' }} </p>
          <p>Length of teaching <span style="color: #000;">{{ info.length_of_teaching }}</span></p>
        </div>
        <span class="info-edit" @click="openInfo">
          <i class="el-icon-edit"></i>
        </span>
      </div>
      <div class="info-heard nodata-info-heard" v-else>
        <span class="edit" @click="infoDialog = true">
          <i class="el-icon-edit"></i>
        </span>
      </div>
      <div class="info-Account">
        <p v-if="info.lark">
          <img class="acc-img" src="../../../assets/acc3.png" alt="">
          <span class="acc">{{ info.lark }}</span>
        </p>
        <p v-if="info.skype">
          <img class="acc-img" src="../../../assets/acc4.png" alt="">
          <span class="acc">{{ info.skype }}</span>
        </p>
        <p v-if="info.wechat">
          <img class="acc-img" src="../../../assets/acc2.png" alt="">
          <span class="acc">{{ info.wechat }}</span>
        </p>
        <p v-if="info.fb">
          <img class="acc-img" src="../../../assets/acc1.png" alt="">
          <span class="acc">{{ info.fb }}</span>
        </p>
      </div>
      <div class="info-main">
        <!-- Life Photos -->
        <div class="Photos">
          <h3>
            Life Photos
          </h3>
          <div class="editclass" @click="openPhotoDialog">
            <i class="el-icon-edit-outline
    "></i>
            Edit
          </div>
          <div class="photo">
            <img v-for="(item, index) in info.life_photos_url" :src="item" :key="index" alt="">
          </div>
        </div>

        <!-- Self introduction video -->
        <div class="Videos">
          <h3>
            Self introduction video
          </h3>
          <div class="editclass" @click="openVideoDialog">
            <i class="el-icon-edit-outline
    "></i>
            Edit
          </div>
          <div class="video">
            <video v-if="info.self_introduction_video_url" style="width: 256px;height: 144px;margin-right: 24px;"
              controls :autoplay="false" :key="info.self_introduction_video_url">
              <source :src="info.self_introduction_video_url" type="video/mp4">
              您的浏览器不支持视频播放。
            </video>
            <span style="word-break: break-all;">

              {{ info.self_introduction }}
            </span>
          </div>
        </div>

        <!-- Teaching Certification -->
        <div class="Certifications">
          <h3>
            Teaching Certification
          </h3>
          <div class="editclass2">
            <i class="el-icon-circle-plus-outline" @click="openCerDialog"></i>
          </div>
          <div class="certification" v-if="info.teaching_certification && info.teaching_certification.length">
            <div v-for="item in info.teaching_certification" :key="item.cate_id" class="cer-item"
              @mouseenter.stop.prevent="isShowEdit = item.cate_id">
                  <el-carousel height="260px" style="width: 220px;" :autoplay="false" indicator-position="none">

      <el-carousel-item v-for="imgUrl in item.degree_image_url" :key="imgUrl">
        <img style="width: 220px;height: 260px;" :src="imgUrl" alt="暂无数据">
      </el-carousel-item>
    </el-carousel>
              <!-- <div style="width: 220px;">
                <img v-for="imgUrl in item.degree_image_url" :key="imgUrl" style="width: 220px;height: 260px;" :src="imgUrl" alt="暂无数据">
              </div> -->
              <div class="cer-item-r" style="max-width: 75%;">
                <p class="inforow">
                  <span class="inforow-l">Certificate Name</span>
                  <span class="inforow-r">{{ item.certificate_name }}</span>
                </p>
                <p class="inforow">
                  <span class="inforow-l">Issuing Agency</span>
                  <span class="inforow-r">{{ item.issuing_agency }}</span>
                </p>
                <p class="inforow">
                  <span class="inforow-l">Certificate End Date</span>
                  <span class="inforow-r">{{ item.certificate_end_date }}</span>
                </p>
                <p class="inforow">
                  <span class="inforow-l">Certificate Description</span>
                </p>
                <div>{{ item.certification_description }}</div>
                <div :class="isShowEdit == item.cate_id ? 'animated-div' : 'disnone'">

                  <span class="info-edit two" :class="isShowEdit == item.cate_id ? 'animated-div' : ''">
                    <i class="el-icon-edit" @click="editCer(item)"></i>
                    <i class="el-icon-delete" @click.stop.prevent="deleteCer2(item.cate_id)"></i>
                    <!-- <el-popover placement="top" width="160" v-model="item.isDel">
                      <p>This operation will permanently delete the education experience. Do you continue?</p>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="item.isDel = false">cancel</el-button>
                        <el-button type="primary" size="mini" @click="deleteCer2">confirm</el-button>
                      </div>
                      <div slot="reference">
                        <i class="el-icon-delete" @click.stop.prevent="deleteCer1(item)"></i>
                      </div>
                    </el-popover> -->
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Education -->
        <div class="Certifications Education">
          <h3>
            Education
          </h3>
          <div class="editclass2">
            <i class="el-icon-circle-plus-outline" @click="openEduDialog"></i>
          </div>
          <div class="certification" v-if="info.graduation_institution && info.graduation_institution.length">
            <div v-for="item in info.graduation_institution" :key="item.id" class="cer-item"
              @mouseenter.stop.prevent="isShowEdit = item.graduate_id">
              <el-carousel height="260px" style="width: 220px;" :autoplay="false" indicator-position="none">
      <el-carousel-item v-for="imgUrl in item.degree_image_url" :key="imgUrl">
        <img style="width: 220px;height: 260px;" :src="imgUrl" alt="暂无数据">
      </el-carousel-item>
    </el-carousel>

              <!-- <img style="width: 220px;height: 260px;" :src="item.degree_image_url" alt=""> -->
              <div class="cer-item-r">
                <p class="inforow">
                  <span class="inforow-l">University</span>
                  <span class="inforow-r">{{ item.university }}</span>
                </p>
                <p class="inforow">
                  <span class="inforow-l">Degree</span>
                  <span class="inforow-r">{{ item.degree_text }}</span>
                </p>
                <p class="inforow">
                  <span class="inforow-l">Major</span>
                  <span class="inforow-r">{{ item.major }}</span>
                </p>
                <p class="inforow">
                  <span class="inforow-l">Graduation Time </span>
                  <span class="inforow-r">{{ item.graduation_time }}</span>
                </p>
                <div :class="isShowEdit == item.graduate_id ? 'animated-div' : 'disnone'">
                  <span class="info-edit two" :class="isShowEdit == item.graduate_id ? 'animated-div' : ''">
                    <i class="el-icon-edit" @click="editEdu(item)"></i>
                    <i class="el-icon-delete" @click.stop.prevent="deleteEdu2(item.graduate_id)"></i>
                    <!-- <el-popover placement="top" width="160" v-model="item.isDel">
                      <p>This operation will permanently delete the education experience. Do you continue?</p>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="item.isDel = false">cancel</el-button>
                        <el-button type="primary" size="mini" @click="deleteEdu2">confirm</el-button>
                      </div>
                      <div slot="reference">

                        <i class="el-icon-delete" @click.stop.prevent="deleteEdu1(item)"></i>
                      </div>
                    </el-popover> -->
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 个人信息弹框 -->
    <el-dialog :visible.sync="infoDialog" title="Basic Information" width="570px" custom-class="editdetailDialog"
      @close="closeFlag">
      <div>
        <el-form :model="infoForm" status-icon label-position="left" :rules="infoRules" ref="infoForm"
          label-width="150px" class="demo-ruleForm">
          <el-form-item label="Gender" prop="gender">
            <el-select v-model="infoForm.gender" collapse-tags style="width: 100%;" placeholder="Please enter your Gender">
              <el-option v-for="item in selectData.gender" :key="item.type" :label="item.name" :value="item.type">{{
                item.name }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Length of teaching" prop="time">
            <el-date-picker style="width: 100%;" v-model="infoForm.teach_start_time" value-format="yyyy-MM-dd"
                            type="month" :picker-options="forbiddenStartTime" placeholder="Select your Certificate End Date">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Lark" prop="">
            <el-input v-model="infoForm.lark" placeholder="Please enter your Lark"></el-input>
          </el-form-item>
          <el-form-item label="Skype" prop="">
            <el-input v-model="infoForm.skype" placeholder="Please enter your Skype"></el-input>
          </el-form-item>
          <el-form-item label="WeChat" prop="">
            <el-input v-model="infoForm.wechat" placeholder="Please enter your WeChat"></el-input>
          </el-form-item>
          <el-form-item label="Face Book" prop="">
            <el-input v-model="infoForm.fb" placeholder="Please enter your Face Book"></el-input>
          </el-form-item>
          <span class="dialog-footer">
            <el-button class="cancelbtn1" @click="infoDialog = false">Cancel</el-button>
            <el-button class="Confirmbtn1" @click="infoSubmit('infoForm')">Confirm</el-button>
          </span>
        </el-form>
      </div>
    </el-dialog>

    <!-- 生活照片上传弹框 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="photoDialog" title="Life Photos" width="670px"
      custom-class="editdetailDialog" @close="closeFlag">
      <div>
        <div>
          <p class="photo-top-title">Photo Introduction <span
              style="color: #ff6b4a;display: inline-block;margin-right: 32px;">*</span><span class="subhead">This
              section is
              visible to parents</span></p>
          <div class="photo-box">
            <div class="photo-up-class" v-for="(item, index) in diaPhotos" :key="index" @mouseenter="showUtils(item)"
              @mouseleave="curPhotoIndex = false">
              <img class="photo" :src="item" alt="">
              <!-- 删除按钮 -->
              <img @click="delphoto(index)" v-show="item === curPhotoIndex" class="del" src="../../../assets/updel.png"
                alt="">
            </div>
            <div v-if=" temList && temList.length <= 9 || diaPhotos && diaPhotos.length <= 9" class="photo-up-class" @click="uploadPhoto">
              <img src="../../../assets/upimg.png" alt="">
            </div>
          </div>
          <p class="subhead">File in .png, .jpg, .jpeg types, less than 3MB.</p>
          <p class="subhead" style="color: #FF904D;">Updated photo will be reviewed by the platform before being
            displayed.</p>
        </div>
        <span class="dialog-footer">
          <el-button class="cancelbtn1" @click="photoDialog = false">Cancel</el-button>
          <el-button class="Confirmbtn1" @click="photoSubmit">Save</el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 介绍视频上传弹框 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="videoDialog" title="Self introduction video" width="670px"
      custom-class="editdetailDialog" @close="closeFlag">
      <div>
        <div>
          <p class="photo-top-title">Self Introduction <span
              style="color: #ff6b4a;display: inline-block;margin-right: 32px;">*</span></p>
          <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 8 }"
            placeholder="Please enter your brief introduction" v-model="diaVideo.self_introduction">
          </el-input>
        </div>
        <div>
          <p class="photo-top-title">Video Introduction <span
              style="color: #ff6b4a;display: inline-block;margin-right: 32px;">*</span><span class="subhead">This
              section is
              visible to parents</span></p>
          <div class="photo-box video-box">
            <div class="photo-up-class" v-if="diaVideo.self_introduction_video_url">
              <!-- <video class="photo" :src="diaVideo.self_introduction_video_url" alt="" /> -->
              <video style="width: 256px;height: 144px;margin-right: 24px;" controls :autoplay="false">
                <source :src="diaVideo.self_introduction_video_url" type="video/mp4">
                您的浏览器不支持视频播放。
              </video>
              <!-- 删除按钮 -->
              <img @click="delVideo" class="del" src="../../../assets/updel.png" alt="">
            </div>
            <div v-else class="photo-up-class" @click="uploadPhoto">
              <img src="../../../assets/upvideo.png" alt="">
            </div>
          </div>
          <p class="subhead">File in .mp4, .avi, .mov, .wmv types, less than 100MB.</p>
          <p class="subhead" style="color: #FF904D;">Updated photo will be reviewed by the platform before being
            displayed.</p>
        </div>
        <span class="dialog-footer">
          <el-button class="cancelbtn1" @click="videoDialog = false">Cancel</el-button>
          <el-button class="Confirmbtn1" @click="videoSubmit">Save</el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 证书上传弹框 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="cerDialog" title="Teaching Certification" width="670px"
      custom-class="editdetailDialog" @close="closeFlag">
      <div>
        <el-form :model="diaCer" status-icon label-position="left" :rules="cerRules" ref="diaCer" label-width="160px"
          class="demo-ruleForm">
          <el-form-item label="Certificate Name" prop="certificate_name">
            <el-input v-model="diaCer.certificate_name" placeholder="Please enter the name of the certificate"></el-input>
          </el-form-item>
          <el-form-item label="Issuing Agency" prop="issuing_agency">
            <el-input v-model="diaCer.issuing_agency" placeholder="Please enter the issuing agency"></el-input>
          </el-form-item>
          <el-form-item label="Certificate End Date" prop="certificate_end_date">
            <el-date-picker style="width: 100%;" v-model="diaCer.certificate_end_date" value-format="yyyy-MM-dd"
              type="month" :picker-options="forbiddenStartTime" placeholder="Select a date">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Certificate Description" prop="" style="margin-bottom: 0;">
          </el-form-item>
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 6 }"
            placeholder="Please enter your Certificate Description" v-model="diaCer.certification_description">
          </el-input>
          <el-form-item label="Certificate Image" prop="" style="margin-bottom: 0;">
          </el-form-item>
          <div class="photo-box" >
            <template v-if="diaCer.degree_image_url && diaCer.degree_image_url.length">
            <div class="photo-up-class" v-for="(item, index) in diaCer.degree_image_url" :key="index">
                <img class="photo" :src="item" alt="">
                <!-- 删除按钮 -->
                <img @click="delcer(index)" class="del" src="../../../assets/updel.png" alt="">
              </div>
            </template>
            <div class="photo-up-class" @click="uploadPhoto">
              <img src="../../../assets/upimg.png" alt="">
            </div>
          </div>
          <p class="subhead">File in .png, .jpg, .jpeg types, less than 3MB.</p>
          <span class="dialog-footer">
            <el-button class="cancelbtn1" @click="cerDialog = false">Cancel</el-button>
            <el-button class="Confirmbtn1" @click="cerSubmit('diaCer')">Save</el-button>
          </span>
        </el-form>
      </div>
    </el-dialog>

    <!-- 学历上传弹框 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="eduDialog" title="Education" width="670px"
      custom-class="editdetailDialog" @close="closeFlag">
      <div>
        <el-form :model="diaEdu" status-icon label-position="left" :rules="eduRules" ref="diaEdu" label-width="160px"
          class="demo-ruleForm">
          <el-form-item label="University" prop="university">
            <el-input v-model="diaEdu.university" placeholder="Please enter your University"></el-input>
          </el-form-item>
          <el-form-item label="Degree" prop="degree">
            <!-- <el-input v-model="diaEdu.degree_text" placeholder="Please enter your Degree"></el-input> -->
            <el-select v-model="diaEdu.degree" collapse-tags style="width: 100%;" placeholder="Please enter your Degree">
              <el-option v-for="item in selectData.degree" :key="item.type" :label="item.name" :value="item.type">{{
                item.name }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Major" prop="major">
            <el-input v-model="diaEdu.major" placeholder="Please enter your Major"></el-input>
          </el-form-item>
          <el-form-item label="Graduation Time" prop="graduation_time">
            <el-date-picker style="width: 100%;" v-model="diaEdu.graduation_time" value-format="yyyy-MM-dd" type="month" :picker-options="forbiddenStartTime"
              placeholder="Select your Graduation Time">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Degree Image" prop="" style="margin-bottom: 0;">
          </el-form-item>
          <div class="photo-box" >
            <template v-if="diaEdu.degree_image_url && diaEdu.degree_image_url.length">
            <div class="photo-up-class" v-for="(item, index) in diaEdu.degree_image_url" :key="index">
                <img class="photo" :src="item" alt="">
                <!-- 删除按钮 -->
                <img @click="deledu(index)" class="del" src="../../../assets/updel.png" alt="">
              </div>
            </template>
            <div class="photo-up-class" @click="uploadPhoto">
              <img src="../../../assets/upimg.png" alt="">
            </div>
          </div>
          <p class="subhead">File in .png, .jpg, .jpeg types, less than 3MB.</p>
          <span class="dialog-footer">
            <el-button class="cancelbtn1" @click="eduDialog = false">Cancel</el-button>
            <el-button class="Confirmbtn1" @click="eduSubmit('diaEdu')">Save</el-button>
          </span>
        </el-form>
      </div>
    </el-dialog>

    <!-- 文件上传 -->
    <FileUpload ref="upload" @upload-success="uploadOver" :isVideo="isVideo" :accept="accept"
      :maxFileSize="maxFileSize" />
  </div>
</template>
<script>
import FileUpload from './Fileupload.vue'
export default {
  components: {
    FileUpload
  },
  data () {
    return {
      // 基础路径
      baseUrl: '',
      // 菜单列表
      info: {},
      // 审核状态呈现
      reviewStatus: 0,
      // 显示头像编辑
      showEditAvatar: false,
      // 是否对外展示
      showCertification: true,
      // 是否对外展示
      showEducation: true,
      // 列表
      certificationList: [
        {
          id: 0,
          name: 'English 8',
          agency: 'tinjin ligong',
          time: '2028.10.21',
          value: `Certificates, in a general sense, are official documents serving as proof of various aspects. They can be evidence of one's identity, such as digital certificates in the digital realm which are similar to personal ID cards in the real world. Digital certificates, also known as public key certificates, are used in public key infrastructure. They contain information like the public key, the identity of the key owner referred to as the`,
          img: '/src/assets/cer1.png'
        },
        {
          id: 1,
          name: 'English 10',
          agency: 'tinjin ligong',
          time: '2028.10.21',
          value: `Certificates, in a general sense, are official documents serving as proof of various aspects. They can be evidence of one's identity, such as digital certificates in the digital realm which are similar to personal ID cards in the real world. Digital certificates, also known as public key certificates, are used in public key infrastructure. They contain information like the public key, the identity of the key owner referred to as the`,
          img: '/src/assets/cer2.png'
        }
      ],
      // 列表
      eduList: [
        {
          id: 0,
          university: 'Stanford University',
          degree: 'Master‘sdegree',
          Major: 'English',
          time: '2025.12.06',
          img: ''
        },
        {
          id: 2,
          university: 'Stanford University',
          degree: 'Master‘sdegree',
          Major: 'English',
          time: '2025.12.06',
          img: ''
        }
      ],
      // 弹框控制
      infoDialog: false,
      photoDialog: false,
      videoDialog: false,
      cerDialog: false,
      eduDialog: false,
      // 弹框对象
      infoForm: {
        gender: 0,
        length: '',
        lark: '',
        skype: '',
        wechat: '',
        fb: ''
      },
      diaPhotos: {},
      diaVideo: {},
      diaCer: { degree_image_url: [] },
      diaEdu: { degree_image_url: [] },
      // 校验对象
      infoRules: {
        gender: [{ required: true, message: 'Please select your genter', trigger: 'blur' }],
        teach_start_time: [{ required: true, message: 'Please select your start teach time', trigger: 'change' }]
      },
      cerRules: {
        certificate_name: [{ required: true, message: 'Please upload your Certificate Name', trigger: 'blur' }],
        issuing_agency: [{ required: true, message: 'Please upload your Issuing Agency', trigger: 'blur' }],
        certificate_end_date: [{ required: true, message: 'Please select your Certificate End Date', trigger: 'change' }]

      },
      eduRules: {
        university: [{ required: true, message: 'Please center your university', trigger: 'blur' }],
        degree: [{ required: true, message: 'Please select your Degree', trigger: 'change' }],
        major: [{ required: true, message: 'Please center your major', trigger: 'blur' }],
        graduation_time: [{ required: true, message: 'Please select your graduation time', trigger: 'blur' }]
      },
      // 筛选数据
      selectData: {},
      time: '',
      // 上传的是头像/图片/视频/证书/学历
      isUpAvatar: false,
      isPhoto: false,
      isVideo: false,
      isCer: false,
      isEdu: false,
      // 文件上传类型大小限制
      accept: '.png, .jpg, .jpeg',
      maxFileSize: 3145728,
      // 呈现生活照的删除按钮
      curPhotoIndex: '',
      // 暂存未提交的列表
      temList: [],
      // 展示按钮的item
      isShowEdit: false,
      // 删除的id
      delId: '',
      forbiddenStartTime: { // 禁用当前日期之前的日期
        disabledDate: this.disabledDateMethod
      }
    }
  },
  mounted () {
    this.baseUrl = this.$http.default.baseUrl
    this.getInfo()
    this.getselect()
  },
  methods: {
    // 禁止选择当天以及之后的日期4111
    disabledDateMethod (time) {
    // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
      return time.getTime() > Date.now() - 8.64e7 // - 8.64e7 表示可选择当天时间
    },
    // 删除证书
    deleteCer1 (item) {
      item.isDel = true
      this.delId = item.cate_id
    },
    deleteCer2 (id) {
      this.$http.post('/tutor/api/credentDel', { cate_id: id || this.delId }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('Saved successfully!')
          this.getInfo()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    // 删除学历
    deleteEdu1 (item) {
      item.isDel = true
      this.delId = item.graduate_id
    },
    deleteEdu2 (id) {
      this.$http.post('/tutor/api/educateDel', { graduate_id: id || this.delId }).then(res => {
        if (res.data.code == 200) {
          this.$message.success('Saved successfully!')
          this.getInfo()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    // 学历提交
    eduSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.diaEdu.degree_image && this.diaEdu.degree_image.length) {
            if (this.diaEdu.graduate_id) {
              this.$http.post('/tutor/api/educateEdit', this.diaEdu).then(res => {
                if (res.data.code == 200) {
                  this.$message.success('Saved successfully!')
                  this.getInfo()
                  this.eduDialog = false
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              })
            } else {
              this.$http.post('/tutor/api/educateAdd', this.diaEdu).then(res => {
                if (res.data.code == 200) {
                  this.getInfo()
                  this.eduDialog = false
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              })
            }
          } else {
            this.$message({
              message: 'Please upload a picture of your diploma',
              type: 'warning'
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑证书
    editCer (item) {
      this.diaCer = item
      this.$set(this, 'accept', '.png, .jpg, .jpeg')
      this.$set(this, 'maxFileSize', 3145728)
      this.cerDialog = true
      this.isCer = true
    },
    // 编辑学历
    editEdu (item) {
      this.diaEdu = item
      this.$set(this, 'accept', '.png, .jpg, .jpeg')
      this.$set(this, 'maxFileSize', 3145728)
      this.eduDialog = true
      this.isEdu = true
    },
    // 证书提交
    cerSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.diaCer.degree_image && this.diaCer.degree_image.length) {
            if (this.diaCer.cate_id) {
              this.$http.post('/tutor/api/credentEdit', this.diaCer).then(res => {
                if (res.data.code == 200) {
                  this.$message.success('Saved successfully!')
                  this.getInfo()
                  this.cerDialog = false
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              })
            } else {
              this.$http.post('/tutor/api/credentAdd', this.diaCer).then(res => {
                if (res.data.code == 200) {
                  this.getInfo()
                  this.cerDialog = false
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  })
                }
              })
            }
          } else {
            this.$message({
              message: 'Please upload a picture of your certificate of qualification',
              type: 'warning'
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 视频删除
    delVideo () {
      this.diaVideo.self_introduction_video = ''
      this.diaVideo.self_introduction_video_url = ''
    },
    // 个人介绍视频提交
    videoSubmit () {
      if (this.diaVideo.self_introduction && this.diaVideo.self_introduction_video) {
        this.$http.post('/tutor/api/selfEdit', {
          self_introduction_video: this.diaVideo.self_introduction_video,
          self_introduction: this.diaVideo.self_introduction
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('Saved successfully!')
            this.videoDialog = false
            this.info.self_introduction_video_url = this.diaVideo.self_introduction_video_url
            this.info.self_introduction = this.diaVideo.self_introduction
            this.$set(this.info, 'self_introduction_video_url', this.diaVideo.self_introduction_video_url)
            this.$set(this.info, 'self_introduction', this.diaVideo.self_introduction)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })
      } else {
        this.$message.error('Required self_introduction_video or self_introduction.')
      }
    },
    // 生活照编辑提交
    photoSubmit () {
      if (this.temList.length) {
        if (this.temList.length > 10) {
          this.$message.error('You can upload a maximum of ten photos of your life!')
        } else {
          this.$http.post('/tutor/api/lifePhotosEdit', {
            paths: this.temList
          }).then(res => {
            if (res.data.code == 200) {
              this.$message.success('Saved successfully!')
              this.photoDialog = false
              this.getInfo()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          })
        }
      } else {
        this.$message.error('Keep a photo of your life!')
      }
    },
    // 删除当前生活照（假删）
    delphoto (index) {
      this.diaPhotos.splice(index, 1)
      this.temList.splice(index, 1)
    },
    // 删除当前
    delcer (index) {
      this.diaCer.degree_image_url.splice(index, 1)
      this.diaCer.degree_image.splice(index, 1)
    },
    // 删除当前
    deledu (index) {
      this.diaEdu.degree_image_url.splice(index, 1)
      this.diaEdu.degree_image.splice(index, 1)
    },
    // 弹框关闭时
    closeFlag () {
      this.isUpAvatar = false
      this.isPhoto = false
      this.isVideo = false
      this.isCer = false
      this.isEdu = false
      this.temList = []
      this.diaCer = { degree_image_url: [] }
      this.diaEdu = { degree_image_url: [] }
      this.diaVideo = {}
    },
    // 打开生活照上传弹框
    openPhotoDialog () {
      this.isPhoto = true
      this.photoDialog = true
      this.temList = this.info && this.info.life_photos && JSON.parse(JSON.stringify(this.info.life_photos)) ? JSON.parse(JSON.stringify(this.info.life_photos)) : []
      this.diaPhotos = this.info && this.info.life_photos_url && JSON.parse(JSON.stringify(this.info.life_photos_url)) ? JSON.parse(JSON.stringify(this.info.life_photos_url)) : []
      this.$set(this, 'accept', '.png, .jpg, .jpeg')
      this.$set(this, 'maxFileSize', 3145728)
    },
    // 打开视频上传弹框
    openVideoDialog () {
      this.isVideo = true
      this.videoDialog = true
      this.diaVideo = {
        self_introduction_video_url: this.info.self_introduction_video_url,
        self_introduction_video: this.info.self_introduction_video,
        self_introduction: this.info.self_introduction
      }
      this.$set(this, 'accept', '.mp4, .avi, .mov, .wmv')
      this.$set(this, 'maxFileSize', 104857600)
    },
    // 打开新增证书上传弹框
    openCerDialog () {
      this.cerDialog = true
      this.isCer = true
      this.$set(this, 'accept', '.png, .jpg, .jpeg')
      this.$set(this, 'maxFileSize', 3145728)
    },
    // 打开新增证书上传弹框
    openEduDialog () {
      this.eduDialog = true
      this.isEdu = true
      this.$set(this, 'accept', '.png, .jpg, .jpeg')
      this.$set(this, 'maxFileSize', 3145728)
    },
    // 打开头像上传弹框
    openUpload () {
      this.isUpAvatar = true
      this.$set(this, 'accept', '.png, .jpg, .jpeg')
      this.$set(this, 'maxFileSize', 3145728)
      setTimeout(()=>{
        this.$refs.upload.uploadFile()
      })
    },
    // 获取上传结果并调用更新接口
    uploadOver (tem) {
      if (!tem) return
      console.log(tem, '-------------')
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (this.isUpAvatar) {
        // 头像
        this.$http.post('/tutor/api/avaterEdit', {
          avatar: tem[0].path
        }).then(res => {
          if (res.data.code == 200) {
            this.getInfo()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })
      } else if (this.isPhoto) {
        // 生活照
        tem.forEach(element => {
          this.temList.push(element.path)
          this.diaPhotos.push(element.url)
        })
      } else if (this.isVideo) {
        // 视频
        this.diaVideo.self_introduction_video_url = tem.url
        this.diaVideo.self_introduction_video = tem.path
      } else if (this.isCer) {
        // 证书
        if (this.diaCer && !this.diaCer.degree_image) {
          this.diaCer.degree_image = []
        }
        tem.forEach(element => {
          this.diaCer.degree_image.push(element.path)
          this.diaCer.degree_image_url.push(element.url)
        })
        this.$set(this.diaCer, 'degree_image_url', this.diaCer.degree_image_url)
      } else if (this.isEdu) {
        // 学籍
        if (this.diaEdu && !this.diaEdu.degree_image) {
          this.diaEdu.degree_image = []
        }
        tem.forEach(element => {
          this.diaEdu.degree_image.push(element.path)
          this.diaEdu.degree_image_url.push(element.url)
        })
      }
      setTimeout(() => {
        loading.close()
      }, 2000)
    },
    // 获取下拉框数据
    getselect () {
      this.$http.get('/tutor/api/personSelect').then(res => {
        if (res.data.code == 200) {
          this.selectData = res.data.data
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    openInfo () {
      let that = this
      this.infoForm.gender = JSON.parse(JSON.stringify(this.info.gender))
      this.infoForm.fb = JSON.parse(JSON.stringify(this.info.fb))
      this.infoForm.lark = JSON.parse(JSON.stringify(this.info.lark))
      this.infoForm.skype = JSON.parse(JSON.stringify(this.info.skype))
      this.infoForm.wechat = JSON.parse(JSON.stringify(this.info.wechat))
      that.$set(that.infoForm, 'teach_start_time', that.info.teach_start_time)
      this.infoDialog = true
    },

    // 获取基本信息数据
    getInfo () {
      this.$http.get('/tutor/api/personInfo').then(res => {
        if (res.data.code == 200) {
          this.info = res.data.data
          this.$set(this, 'info', res.data.data)
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 调用图片上传
    uploadPhoto () {
      this.$refs.upload.uploadFile()
    },
    // 个人信息提交
    infoSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.infoForm.time_zone = this.utils.getTimeZoneCity()
          this.$http.post('/tutor/api/BasicInfoEdit', this.infoForm).then(res => {
            if (res.data.code == 200) {
              this.$message.success('Saved successfully!')
              this.getInfo()
              this.infoDialog = false
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    showUtils (item) {
      this.curPhotoIndex = item
    }
  }
}
</script>
<style lang="less" scoped>
.Information {
  background: #fff;
  padding: 0 24px;

  .mine_title {
    font-family: Roboto;
    font-size: 24px;
    font-weight: 600;
    font-feature-settings: "kern" on;
    display: inline-block;
  }

  .info {
    margin-top: 48px;

    .info-heard {
      background-image: url('../../../assets//info--tbg.png');
      background-repeat: round;
      display: flex;
      border-radius: 16px;
      padding: 36px 24px;
      position: relative;

      .avatar {
        margin-right: 24px;
        position: relative;
        cursor: pointer;

        .avatar-edit {
          background-color: rgba(0, 0, 0, 0.3);
          text-align: center;
          position: absolute;
          width: 120px;
          top: 0;
          font-size: 36px;
          color: #fff;
          display: flex;
          flex-direction: column;
          height: 120px;
          align-items: center;
          justify-content: center;
          border-radius: 60px;
        }
      }

      .info-name {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        color: #333;
      }

      .info-edit {
        background-color: #FF904D;
        color: #fff;
        font-size: 18px;
        text-align: center;
        line-height: 36px;
        width: 36px;
        height: 36px;
        border-radius: 18px;
        display: inline-block;
        position: absolute;
        right: 32px;
        top: 78px;
        cursor: pointer;
      }
    }

    .info-Account {
      box-shadow: 0px -10px 10px 0px rgba(0, 0, 0, 0.05);
      background-color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      margin-top: -24px;
      border-radius: 16px 16px 16px 16px;
      z-index: 999;
      position: relative;
      height: 72px;
      line-height: 72px;

      p {
        width: 25%;
        display: flex;
        align-items: center;
        padding-left: 24px;
      }

      .acc-img {
        width: 24px;
        height: 24px;
      }

      .acc {
        display: inline-block;
        margin-left: 10px;
      }
    }

    .info-main {
      margin-top: 48px;
      color: #333;

      h3 {
        font-family: Roboto;
        font-size: 36px;
        font-weight: normal;
      }

      .Photos {
        position: relative;

        .photo {
          margin: 16px 0 32px 0;

          img {
            width: 223px;
            height: 220px;
            display: inline-block;
            margin-left: 24px;
            margin-bottom: 16px;
          }
        }
      }

      .Videos {
        position: relative;

        .video {
          display: flex;
          flex-direction: row;
          margin: 24px 0 48px 0;
        }
      }

      .Certifications {
        position: relative;

        .info-edit {
          background-color: #FF904D;
          color: #fff;
          font-size: 18px;
          text-align: center;
          line-height: 36px;
          width: 36px;
          height: 36px;
          border-radius: 18px;
          display: inline-block;
          position: absolute;
          right: 32px;
          top: 78px;
          cursor: pointer;
        }

        .certification {
          margin-bottom: 48px;

          .cer-item {
            margin-top: 24px;
            display: flex;
            flex-direction: row;
            position: relative;
          }

          .cer-item-r {
            margin-left: 24px;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;

            .inforow {
              line-height: 2;
              font-family: Roboto;
              font-size: 16px;
              font-weight: normal;

              .inforow-l {
                color: #6B7280;
                width: 186px;
                display: inline-block;
              }
            }
          }
        }
      }

      .Education {
        .cer-item-r {
          justify-content: flex-start !important;

          .inforow {
            line-height: 3 !important;
          }
        }
      }
    }
  }

  .failed {
    background-color: #FF5E5E;
    color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
    margin-left: 12px;
  }

  .reviewing {
    background-color: #FF904D;
    color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
    margin-left: 12px;
  }

  .successful {
    background-color: #10B981;
    color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
    margin-left: 12px;
  }
}

.editclass {
  color: #ff904D;
  position: absolute;
  right: 20px;
  cursor: pointer;
  top: 20px;
}

.editclass2 {
  font-size: 24px;
  color: #ff904D;
  position: absolute;
  right: 20px;
  cursor: pointer;
  top: 20px;
  display: flex;
  align-items: center;

  i {
    display: inline-block;
    margin-left: 16px;
  }
}

/deep/ .editdetailDialog {
  background: #fffae5;

  .el-dialog__title {
    font-size: 22px;
  }

  .el-dialog__header {
    padding: 24px;
  }

  .el-dialog__body {
    padding: 0 24px 24px 24px !important;

    .codebox {
      display: flex;
      flex-direction: row;

      .codeInput {
        display: inline-block;
      }

      .codebtn {
        background-color: #ff904D;
        margin-left: 20px;
        display: inline-block;
        color: #fff;
      }
    }
  }

  .dialog-footer {
    width: 100%;
  }

  .cancelbtn1 {
    width: 48%;
    background: transparent;
    color: #666;
    border: 1px solid #ccc;
  }

  .Confirmbtn1 {
    width: 48%;
    height: 45px;
    margin-left: 2%;
    color: #fff;
    background: #ff904d;
    border: none;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}

.nodata-info-heard {
  height: 168px;
  display: flex;
  justify-content: center;
  align-items: center;

  .edit {
    cursor: pointer;
    margin-top: -24px;
    width: 120px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    background-color: #ff904d;
    border-radius: 60px;
    color: #fff;
    font-size: 48px;
  }
}

/deep/.el-time-spinner {
  display: flex !important;
}

.photo-top-title {
  font-family: Alibaba PuHuiTi 3.0;
  font-size: 16px;
  font-weight: normal;
  line-height: 30px;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
}

.subhead {
  font-size: 16px;
  font-weight: normal;
  line-height: 30px;
  color: #999;
  display: inline-block;
}

.photo-box {
  display: flex;
  flex-direction: row;
  margin: 8px 0;
  cursor: pointer;
  flex-wrap: wrap;

}
.photo-up-class {
  cursor: pointer;
  width: 132px;
  height: 122px;
  border: 2px dashed #eee;
  text-align: center;
  line-height: 122px;
  border-radius: 8px;
  margin-right: 8px;
  position: relative;
  margin-bottom: 8px;

  .photo {
    width: 132px;
    height: 122px;
  }

  .del {
    position: absolute;
    z-index: 9;
    right: 12px;
    top: 8px;
  }
}

.video-box {
  .photo-up-class {
    width: 216px;

    .photo {
      width: 216px;
    }

    .del {
      right: -21px;
      top: 17px;
    }
  }
}

.two {
  display: flex !important;
  flex-direction: row !important;
  background-color: #FF904D !important;
  width: 88px !important;
  height: 32px !important;
  align-items: center !important;

  i {
    width: 50% !important;
  }

  span {
    width: 50% !important;
    display: inline-block;
    border-left: 1px solid #fff;
  }
}

.animated-div {
  display: inline-block;
  position: absolute;
  right: 32px;
  top: 0px;
  opacity: 0;
  transform: translateX(100%);
  animation: slideInFromRight 0.5s forwards;
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.disnone {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/views/childrens/Personal.vue